var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card-size",on:{"click":_vm.ringCompany}},[_c('v-img',{attrs:{"padding":"10","aspect-ratio":1/1,"src":_vm.image}}),_c('v-card-title',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }